import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';

export const _background: WorkspaceItem = {
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: '_background',
  dataType: '_background',
  numberOfElements: undefined,
  itemType: 'layer',
  name: 'Base Map',
  description: 'Background configuration',
  origin: 'pn',
  createdAt: new Date(0).toISOString(),
  updatedAt: new Date(0).toISOString(),
  createdBy: undefined,
  isShared: false,
  isGlobal: true,
  map: {
    layers: [
      {
        id: '',
        name: 'Base Map',
        type: LayerType.Background,
        style: { color: 'transparent' },
        source: { type: 'raster' },
        sourceLayer: undefined,
      },
    ],
  },
  dataSource: {
    type: 'none',
  },
  detailsSource: 'local',
  query: buildQuery({
    id: '_background',
    dataType: '_background',
  }),
  module: 'background',
  ...createInitInternalState({ isVisualized: false }),
};
